/*
  Páginas de colección (20 oct 2026): "cargar más" y los dos contadores del panel de filtros.

  Lo que NO hace, a propósito:
  - Ordenar: lo sigue haciendo el <custom-select> de siempre (assets/custom.js), que ya
    escribe en el <select> oculto y envía el formulario. Aquí solo se repinta con CSS.
  - Filtrar: lo sigue haciendo facets.js.

  "Cargar más" es una MEJORA sobre un enlace real a ?page=N. Si este guion no se carga o
  falla, el enlace lleva a la página siguiente y la web funciona igual.
*/

(() => {
  'use strict';

  /* ─────────────── Cargar más ─────────────── */

  class BtnCargarMas {
    constructor(raiz) {
      this.raiz = raiz;
      this.boton = raiz.querySelector('[data-btn-mas]');
      this.contador = raiz.querySelector('[data-btn-contador]');
      this.progreso = raiz.querySelector('[data-btn-progreso]');
      this.rejilla = document.getElementById('product-grid');
      if (!this.boton || !this.rejilla) return;

      this.total = parseInt(raiz.dataset.total, 10) || 0;
      this.porPagina = parseInt(raiz.dataset.porPagina, 10) || 12;
      this.vistas = parseInt(raiz.dataset.vistas, 10) || 0;

      this.boton.addEventListener('click', (e) => this.alPulsar(e));
    }

    async alPulsar(evento) {
      // Con Cmd/Ctrl/mayúsculas o botón central se deja pasar: el usuario quiere otra pestaña.
      if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.button !== 0) return;
      evento.preventDefault();

      const url = this.boton.getAttribute('href');
      if (!url || this.boton.getAttribute('aria-busy') === 'true') return;

      this.boton.setAttribute('aria-busy', 'true');
      try {
        const resp = await fetch(url);
        if (!resp.ok) throw new Error('respuesta ' + resp.status);
        const html = new DOMParser().parseFromString(await resp.text(), 'text/html');

        const nuevaRejilla = html.getElementById('product-grid');
        if (!nuevaRejilla) throw new Error('sin rejilla');

        const tarjetas = nuevaRejilla.querySelectorAll(':scope > li');
        if (!tarjetas.length) throw new Error('sin prendas');
        tarjetas.forEach((li) => this.rejilla.appendChild(li));

        // El siguiente enlace sale de la página que acabamos de traer.
        const siguiente = html.querySelector('[data-btn-mas]');
        if (siguiente) {
          this.boton.setAttribute('href', siguiente.getAttribute('href'));
        } else {
          this.boton.hidden = true;
        }

        this.vistas = Math.min(this.vistas + this.porPagina, this.total);
        this.pintarAvance(html);

        // La dirección del navegador acompaña a lo que se está viendo, sin recargar:
        // así el botón "atrás" y el compartir enlace siguen teniendo sentido.
        window.history.replaceState({}, '', url);
      } catch (error) {
        // Si algo falla, se deja el enlace normal: al siguiente clic navega de verdad.
        console.warn('No se pudo cargar más:', error);
        this.boton.removeEventListener('click', this.alPulsar);
        window.location.href = url;
      } finally {
        this.boton.removeAttribute('aria-busy');
      }
    }

    pintarAvance(htmlNuevo) {
      if (this.progreso && this.total > 0) {
        this.progreso.style.width = Math.round((this.vistas / this.total) * 100) + '%';
      }
      if (!this.contador) return;
      // El texto traducido se coge de la página nueva, para no armarlo aquí a mano
      // (en /es/ dice "24 de 144 prendas", con su orden de palabras).
      const nuevoContador = htmlNuevo && htmlNuevo.querySelector('[data-btn-contador]');
      if (nuevoContador) this.contador.textContent = nuevoContador.textContent.trim();
    }
  }

  const arrancarCargarMas = () => {
    document.querySelectorAll('[data-btn-load-more]').forEach((raiz) => {
      if (raiz.dataset.btnListo) return;
      raiz.dataset.btnListo = '1';
      new BtnCargarMas(raiz);
    });
  };

  /* ─────────────── Contadores del panel de filtros ─────────────── */

  /*
    Dos números que el tema no traía y que pide el diseño:
      · "N SELECTED" en la cabecera del panel;
      · "SHOW N PIECES" en el botón negro de abajo.
    Se calculan contando las casillas marcadas dentro del propio panel, así que no
    hacen ninguna petición y se actualizan al instante. El número de prendas definitivo
    lo sigue poniendo el servidor cuando facets.js recarga la rejilla.
  */
  const actualizarPanel = () => {
    const panel = document.querySelector('.btn-collection .mobile-facets');
    if (!panel) return;

    const marcadas = panel.querySelectorAll('input[type="checkbox"]:checked').length;
    const etiqueta = document.querySelector('.btn-collection [data-btn-seleccionados]');
    if (etiqueta) {
      etiqueta.hidden = marcadas === 0;
      // El hueco es __N__ y no {{ count }}: unas llaves dobles dentro de una cadena de
      // Liquid rompen el analizador y dejan la plantilla entera sin pintar.
      const plantilla = etiqueta.dataset.plantilla || '__N__ SELECTED';
      etiqueta.textContent = plantilla.replace('__N__', marcadas);
    }

    // "SHOW N PIECES": el número sale de la línea pequeña, que es la que facets.js
    // vuelve a pintar al filtrar. El botón del panel no está dentro de ese contenedor,
    // así que si no se copia aquí se queda con el número de la carga inicial.
    const ver = document.querySelector('.btn-collection [data-btn-ver]');
    const meta = document.querySelector('.btn-collection [data-btn-total]');
    if (ver && meta && ver.dataset.plantilla) {
      // Una prenda no es "1 PIECES": el singular viene aparte, ya traducido por Shopify.
      const total = meta.dataset.btnTotal;
      ver.textContent =
        total === '1' && ver.dataset.plantillaUna
          ? ver.dataset.plantillaUna
          : ver.dataset.plantilla.replace('__N__', total);
    }
  };

  const vigilarPanel = () => {
    const panel = document.querySelector('.btn-collection .mobile-facets');
    if (!panel || panel.dataset.btnVigilado) return;
    panel.dataset.btnVigilado = '1';
    panel.addEventListener('change', actualizarPanel);
    actualizarPanel();
  };

  /* ─────────────── Texto SEO del final ─────────────── */

  /*
    El bloque se pliega y se despliega solo, porque es un <details>: esto únicamente
    añade dos cosas que el <details> no da por sí mismo.
      · `aria-expanded` en la fila de la flecha, que el diseño pide explícitamente.
        En el HTML nace en "false", que es correcto con el bloque plegado, así que
        sin este guion tampoco miente.
      · El botón "READ LESS" del final, que cierra el bloque y devuelve el dedo
        arriba, al título, en vez de dejarte perdido a mitad de página.
  */
  const arrancarSeo = () => {
    document.querySelectorAll('.btn-seo__det').forEach((det) => {
      if (det.dataset.btnListo) return;
      det.dataset.btnListo = '1';

      const resumen = det.querySelector('.btn-seo__sum');
      if (resumen) {
        det.addEventListener('toggle', () => {
          resumen.setAttribute('aria-expanded', det.open ? 'true' : 'false');
        });
      }

      const cerrar = det.querySelector('[data-btn-seo-cerrar]');
      if (cerrar) {
        cerrar.addEventListener('click', () => {
          det.open = false;
          if (resumen) {
            resumen.setAttribute('aria-expanded', 'false');
            resumen.scrollIntoView({ block: 'nearest' });
            resumen.focus({ preventScroll: true });
          }
        });
      }
    });
  };

  /* ─────────────── Arranque y re-arranque ─────────────── */

  const arrancar = () => {
    arrancarCargarMas();
    vigilarPanel();
    actualizarPanel();
    arrancarSeo();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // facets.js vuelve a pintar la rejilla al filtrar u ordenar (sustituye entero el
  // innerHTML de #ProductGridContainer), así que hay que engancharse a los elementos
  // nuevos. Se vigila SOLO ese contenedor, no todo el documento, y con un respiro:
  // vigilar el documento entero dispararía esto en cada cambio de la página.
  let pendiente = null;
  const alRepintar = () => {
    clearTimeout(pendiente);
    pendiente = setTimeout(arrancar, 50);
  };

  const vigilarRejilla = () => {
    const cont = document.getElementById('ProductGridContainer');
    if (!cont || cont.dataset.btnVigilado) return;
    cont.dataset.btnVigilado = '1';
    new MutationObserver(alRepintar).observe(cont, { childList: true, subtree: true });
  };

  vigilarRejilla();
  document.addEventListener('shopify:section:load', () => {
    arrancar();
    vigilarRejilla();
  });
})();
